module.exports = __webpack_public_path__ + "iconWhite.webp?224761a4b9b52411212f1c98d218818f";